import type { IMessage } from '@dev-fast/types';
import { CS2_NICKNAME, EMessageType, EWalletType } from '@dev-fast/types';

export const createTipleJackpotChatMessage = (jackpotStatus: {
  timestamp?: string;
  amount?: number;
  winnersCount?: number;
  sequence?: number;
  walletType?: EWalletType;
}): IMessage => {
  return {
    type: jackpotStatus.sequence ? EMessageType.DOUBLE_GREEN : EMessageType.DOUBLE,
    user: {
      id: 0,
      name: CS2_NICKNAME,
      avatar: '',
    },
    createdAt: jackpotStatus.timestamp ?? new Date().toISOString(),
    id: Date.now().toString(),
    value: {
      amount: +(jackpotStatus.amount ?? 0),
      userCount: jackpotStatus.winnersCount ?? 0,
      sequence: jackpotStatus.sequence ?? 0,
      walletType: jackpotStatus.walletType ?? EWalletType.REAL,
    },
    valueParams: {},
    game: 'double',
  };
};
